/* eslint-disable no-loop-func, no-case-declarations, no-console */
import { onError } from '@apollo/client/link/error';
import { captureException, close } from '@sentry/react';

import { ERROR_TRACE } from 'src/constants/localState';
import { AppRoutes } from 'src/pages/AppRoutes';

import { handleErrors } from './handleErrors';

export const errorMiddleware = onError(({ graphQLErrors, networkError, operation, response }) => {
  if (graphQLErrors) {
    const didHandleError = handleErrors(graphQLErrors, operation);
    if (didHandleError && response) {
      response.errors = undefined;
    }
    if (!didHandleError) {
      for (const err of graphQLErrors) {
        captureException(err);
      }
    }
  }

  if (networkError) {
    // eslint-disable-next-line no-console
    console.error(`[Network error]: ${networkError}`);

    captureException(JSON.stringify(networkError));

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    close(2000).then(function () {
      sessionStorage.setItem(ERROR_TRACE, JSON.stringify(networkError));

      // eslint-disable-next-line require-atomic-updates
      window.location.href = AppRoutes.Error;
    });
  }
});
